import { PipelineTypeBase } from './base/pipeline-type-base';

export class PipelineType extends PipelineTypeBase { }